import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import velocity from 'velocity-animate'
import $ from 'jquery'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import Loading from 'vue-loading-overlay'
import Form from './services/form'
import helper from './services/helper'
import showError from './components/ShowError'
import ClientOnly from 'vue-client-only/dist/vue-client-only.common'
import axios from 'axios'

import('uikit/dist/css/uikit.css')
import('@/plugins/directives.client')
import('@/plugins/filters')
import('@/plugins/mixins.client')
import('@/plugins/waves.client')
import('@/plugins/retina.client')
import('@/plugins/gmaps')
import('@/plugins/fblogin')
import('@/plugins/googlelogin')
import('@/plugins/moment')

import('@/assets/vendor/uikit')
import('@/assets/fonts/mdi_base64.css')
import('@/assets/fonts/montserrat_base64.css')
import('@/assets/fonts/roboto_base64.css')
import('@/assets/fonts/poppins_base64.css')
import('@/assets/fonts/sourceCodePro_base64.css')
import('@/assets/fonts/materialdesignicons.css')
import('@/assets/scss/main.scss');


UIkit.use(Icons);

Vue.use(VueCookie);
Vue.use(Loading);
Vue.component(ClientOnly.name, ClientOnly);
Vue.component('showError',showError);

window.UIkit = UIkit;
window.velocity = velocity;
window.Vue = Vue;
window.$ = $;
//window.moment = require('vue-moment')
window._get = require('lodash/get');
window._has = require('lodash/has');
window._size = require('lodash/size');

window.axios = axios;
window.Form = Form;
window.helper = helper;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + Vue.cookie.get('auth_token');


/*window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(response => {
  return response.data
});*/

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

/*
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
*/






// WEBPACK FOOTER //
// ./src/bootstrap.js